export default __webpack_public_path__ + "static/media/logo-rasad.bcd687a6.png";